<template>
  <div class="bild-auswahl">
    <img v-if="Vorschau" :src="Vorschau" class="bild-vorschau" alt="" @error="VorschauFehler" />

    <div class="bild-buttons">
      <button v-if="IstTouch" type="button" class="bild-btn" @click="KameraOeffnen">
        <font-awesome-icon icon="fa-solid fa-camera" />
        {{ Vorschau ? 'Neu aufnehmen' : 'Foto aufnehmen' }}
      </button>
      <button type="button" class="bild-btn" @click="DateiOeffnen">
        <font-awesome-icon icon="fa-solid fa-image" />
        Bild auswählen
      </button>
      <button v-if="Vorschau" type="button" class="bild-btn bild-btn--loeschen" @click="Entfernen">
        <font-awesome-icon icon="fa-solid fa-trash" />
        Entfernen
      </button>
    </div>

    <p v-if="Fehler" class="error-message">{{ Fehler }}</p>

    <input
      ref="KameraInput"
      type="file"
      accept="image/*"
      capture="environment"
      class="bild-input-versteckt"
      @change="DateiGewaehlt"
    />
    <input
      ref="DateiInput"
      type="file"
      accept="image/*"
      class="bild-input-versteckt"
      @change="DateiGewaehlt"
    />
  </div>
</template>

<script>
import { IstTouchGeraet, DateiZuVorschaubild } from '../composables/useBilder'

export default {
  name: 'BildAuswahl',
  props: {
    // undefined = unverändert, null = entfernt, String = neue JPEG-Data-URL
    modelValue: { type: String, default: undefined },
    // URL eines bereits gespeicherten Bildes (Bearbeiten-Ansichten)
    bestehendUrl: { type: String, default: null }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      IstTouch: IstTouchGeraet(),
      Fehler: '',
      BestehendKaputt: false
    }
  },
  computed: {
    Vorschau() {
      if (typeof this.modelValue === 'string') return this.modelValue
      if (this.modelValue === null) return null
      return this.BestehendKaputt ? null : this.bestehendUrl
    }
  },
  methods: {
    KameraOeffnen() {
      this.$refs.KameraInput.click()
    },
    DateiOeffnen() {
      this.$refs.DateiInput.click()
    },
    async DateiGewaehlt(Ereignis) {
      const Datei = Ereignis.target.files && Ereignis.target.files[0]
      Ereignis.target.value = ''
      if (!Datei) return
      this.Fehler = ''
      try {
        const DataUrl = await DateiZuVorschaubild(Datei)
        this.$emit('update:modelValue', DataUrl)
      } catch {
        this.Fehler = 'Das Bild konnte nicht verarbeitet werden.'
      }
    },
    Entfernen() {
      this.Fehler = ''
      this.$emit('update:modelValue', null)
    },
    VorschauFehler(Ereignis) {
      if (Ereignis.target.src === this.bestehendUrl) {
        this.BestehendKaputt = true
      }
    }
  }
}
</script>

<style scoped>
.bild-auswahl {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.bild-vorschau {
  width: 104px;
  height: 104px;
  border-radius: var(--radius-lg);
  object-fit: cover;
  border: 1px solid var(--glas-rand);
  box-shadow: var(--glas-schatten);
}

.bild-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bild-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: none;
  border-radius: 999px;
  background: var(--akzent-weich);
  color: var(--color-primary);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.bild-btn:hover {
  background: color-mix(in srgb, var(--color-primary) 24%, transparent);
  transform: translateY(-1px);
}

.bild-btn:active {
  transform: scale(0.95);
}

.bild-btn--loeschen {
  background: color-mix(in srgb, var(--color-danger) 10%, transparent);
  color: var(--color-danger);
}

.bild-btn--loeschen:hover {
  background: color-mix(in srgb, var(--color-danger) 18%, transparent);
}

.bild-input-versteckt {
  display: none;
}
</style>
